import React, { useRef, useState } from "react";
import { TopButs } from "./TopButs";
import { FormBox } from "./FormBox";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { IYhFormRef } from "@/components/YhFormBox/Types";
import { TabBar } from "./TabBar";
import { SettleDrawer } from "./SettleDrawer";
import { ReceiptSettleDrawer } from "./receiptSettleDrawer";
import { TableBoxMethod } from "./TableBoxMethod";

export const PurchasesDetails = () => {
    const { getSelectedNavState } = useNavModel(() => []);
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const formRef = useRef<IYhFormRef>();
    return (
        <>
            {detailsInfo && <>
                <TopButs formRef={formRef} {...detailsInfo} />
                <FormBox formRef={formRef} {...detailsInfo} />
                <TableBoxMethod {...detailsInfo} />
                <TabBar {...detailsInfo} />
                {/* <SettleDrawer /> */}
                <ReceiptSettleDrawer />
            </>
            }
        </>
    )
}